<script lang="ts" setup>
import type { BreadcrumbEllipsisProps } from '.';

import { cn } from '@/utils';

const props = defineProps<BreadcrumbEllipsisProps>();
</script>

<template>
	<span
		role="presentation"
		aria-hidden="true"
		:class="cn('flex h-9 w-9 items-center justify-center', props.class)"
	>
		<slot>
			<IconPilarMoreHoriz class="size-4" />
		</slot>
		<span class="sr-only">More</span>
	</span>
</template>
